<template>
  <div class="checkout-product">
    <div v-if="$props.productImage"
         class="image">
      <img :src="$props.productImage"
           :alt="$props.productName"
           height="60"/>
      <span v-if="$props.productColor"
            :style="colorStyles"
            class="color-marker"></span>
    </div>
    <div class="description">
      <h6 v-if="$props.productBrand">{{ $props.productBrand }}</h6>
      <h2>
        {{ $props.productName }}
        <hover-tooltip v-if="$props.hasTooltip && $props.productTooltip"
                       class="product-tooltip"
                       :content="$props.productTooltip"/>
      </h2>
      <span v-if="$props.productSummary">{{ $props.productSummary }}</span>
    </div>
  </div>
</template>

<script>
import HoverTooltip from '@/components/common/hover-tooltip'

export default {
  name: 'checkout-row-product',
  components: { HoverTooltip },
  props: {
    productImage: String,
    productName: String,
    productBrand: String,
    productColor: {
      type: Object,
      default: () => ({})
    },
    productTooltip: String,
    hasInfoButton: Boolean,
    hasTooltip: Boolean,
    productSummary: String
  },
  computed: {
    colorStyles () {
      if (this.$props.productColor) {
        if (this.$props.productColor.type === 'image') {
          return {
            background: `url(${this.$props.productColor.value}) center center no-repeat`
          }
        }
        return {
          backgroundColor: this.$props.productColor.value
        }
      }
      return false
    }
  },
  methods: {
    emitInfoClick () {
      this.$emit('info-click')
    }
  }
}
</script>

<style scoped lang="scss">
.checkout-product {
  display: flex;
  align-items: center;

  .image {
    position: relative;
    margin-right: 1.6rem;
    width: 7.2rem;
    text-align: center;

    img {
      height: 60px;
      width: auto;
    }

    .color-marker {
      position: absolute;
      top: -0.8rem;
      left: 0;
      width: 1.6rem;
      height: 1.6rem;
      border: 1px solid $form-border-color;
      border-radius: 50%;
      background-color: transparent;
      background-size: cover !important;
    }
  }

  .description {

    h6 {
      font-size: 1.2rem;
      line-height: 2rem;
      margin: 0;
      text-transform: uppercase;
    }

    h2 {
      font-size: 1.8rem;
      line-height: 2rem;
      margin: 0;

      .product-tooltip {
        margin: 0 0 4px 8px;
      }
    }
  }
}
</style>
